
const resizeFunction=()=>
    {
        const ctaType9 = document.querySelectorAll('.cta.cta--type9.cta--large .headline');
        if(ctaType9.length>0){
            if(window.innerWidth <= 1000){
                ctaType9[0].innerHTML="Pflegehilfsmittel";
            }
            else{
                ctaType9[0].innerHTML="Pflege-hilfsmittel";
            }
        }
        const ctaType4 = document.querySelectorAll('.cta.cta--type4.cta--large .cta__icon__text');
        if(ctaType4.length>0 && ctaType4[2]){
            if(window.innerWidth <= 1000){
                ctaType4[2].innerHTML="Sichere Daten-Übermittlung";
            }
            else{
                ctaType4[2].innerHTML="Sichere DatenÜbermittlung";
            }
        }
        const ctaType5 = document.querySelectorAll('.cta.cta--type5.cta--large .button__text');
        if(ctaType5.length>0){
            if(window.innerWidth <= 1000){
                ctaType5[0].innerHTML="Jetzt kostenfrei anmelden";
            }
            else{
                ctaType5[0].innerHTML="Pflegeantrag kostenfrei stellen";
            }
        }
    };
resizeFunction();
addEventListener("resize", (event) => {});

onresize = (event) => {
    resizeFunction();
};
    